import { render, staticRenderFns } from "./CreditHistory.vue?vue&type=template&id=b063ae92&scoped=true"
import script from "./CreditHistory.vue?vue&type=script&lang=js"
export * from "./CreditHistory.vue?vue&type=script&lang=js"
import style0 from "./CreditHistory.vue?vue&type=style&index=0&id=b063ae92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b063ae92",
  null
  
)

export default component.exports